/**
 * Tujuan: Menampilkan daftar sertifikat dengan gambar preview dan link ke credential
 * Caller: App.js route /certifications
 * Dependensi: react-bootstrap (Container, Row, Col, Modal), react-icons, certificate image assets
 * Main Functions: Certifications()
 * Side Effects: useState for modal open/close
 */
import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { FaLinkedin, FaCertificate } from "react-icons/fa";

import imgBusinessAnalysis from "../assets/cert-business-analysis.jpg";
import imgSqlIntermediate from "../assets/cert-sql-intermediate.jpg";
import imgIntroSql from "../assets/cert-intro-sql.jpg";
import imgIntroPython from "../assets/intro python.jpg";
import imgIntroJavascript from "../assets/cert-intro-javascript.jpg";

const certs = [
  {
    title: "What Is Business Analysis?",
    issuer: "LinkedIn Learning",
    icon: <FaLinkedin className="cert-icon-small" />,
    image: imgBusinessAnalysis,
    link: "https://www.linkedin.com/learning/certificates/c4c1199a36002ffc47e616f8fb8ddcb94ac3c91cb20a63042d37619447242f18?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3B8%2FFHexVoTkWXV0fhPH8FXA%3D%3D",
  },
  {
    title: "SQL Intermediate",
    issuer: "Sololearn",
    icon: <FaCertificate className="cert-icon-small" />,
    image: imgSqlIntermediate,
    link: "https://www.sololearn.com/en/certificates/CC-H7PHOBWS",
  },
  {
    title: "Introduction to SQL",
    issuer: "Sololearn",
    icon: <FaCertificate className="cert-icon-small" />,
    image: imgIntroSql,
    link: "https://www.sololearn.com/en/certificates/CC-VHSIXRUW",
  },
  {
    title: "Introduction to Python",
    issuer: "Sololearn",
    icon: <FaCertificate className="cert-icon-small" />,
    image: imgIntroPython,
    link: "https://www.sololearn.com/certificates/CC-1CTRP4W1",
  },
  {
    title: "Introduction to JavaScript",
    issuer: "Sololearn",
    icon: <FaCertificate className="cert-icon-small" />,
    image: imgIntroJavascript,
    link: "https://www.sololearn.com/en/certificates/CC-SWE8Q7W9",
  },
];

function Certifications() {
  const [showModal, setShowModal] = useState(false);
  const [activeImage, setActiveImage] = useState(null);
  const [activeTitle, setActiveTitle] = useState("");

  const handleImageClick = (image, title) => {
    setActiveImage(image);
    setActiveTitle(title);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setActiveImage(null);
    setActiveTitle("");
  };

  return (
    <Container fluid className="about-section">
      <Container className="section-container">

        <h1 className="text-center mb-5">
          My <span className="blue">Certifications</span>
        </h1>

        <Row className="g-4">
          {certs.map((cert, index) => (
            <Col md={4} key={index}>
              <div className="cert-card-image">

                {/* Certificate image */}
                <div className="cert-img-container">
                  <img
                    src={cert.image}
                    alt={cert.title}
                    className="cert-img"
                    onClick={() => handleImageClick(cert.image, cert.title)}
                  />
                </div>

                {/* Card content */}
                <div className="cert-content">
                  <div className="cert-header-small">
                    {cert.icon}
                    <div>
                      <h4 className="cert-title-small">{cert.title}</h4>
                      <p className="cert-issuer-small">{cert.issuer}</p>
                    </div>
                  </div>
                  <a
                    href={cert.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cert-btn-small mt-3 d-inline-block"
                  >
                    View Credential
                  </a>
                </div>

              </div>
            </Col>
          ))}
        </Row>

      </Container>

      {/* Lightbox modal for certificate preview */}
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header
          closeButton
          style={{ borderBottom: "none", background: "#0b1622" }}
        >
          <Modal.Title style={{ color: "#e6edf3", fontSize: "0.95rem" }}>
            {activeTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, background: "#0b1622", textAlign: "center" }}>
          {activeImage && (
            <img
              src={activeImage}
              alt={activeTitle}
              className="img-fluid w-100"
              style={{ objectFit: "contain", maxHeight: "80vh" }}
            />
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default Certifications;
